import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_LetterRequestCustomer_List_Interface, LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterrequestcustomerFactorService } from 'src/app/Service/Letter/LetterrequestcustomerFactor.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-LetterrequestcustomerFactorForm',
  templateUrl: './LetterrequestcustomerFactorForm.component.html',
  styleUrls: ['./LetterrequestcustomerFactorForm.component.scss']
})
export class LetterrequestcustomerFactorFormComponent implements OnInit {

  @Input() inner_Letter: LetterRequestCustomer_List_Interface = Empty_LetterRequestCustomer_List_Interface()
  @Output() OnBack_LetterrequestcustomerFactor_Action = new EventEmitter<number>();
  Token: String = ""
  Filter_title: string = ""
  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;

  constructor(
    private LetterrequestcustomerFactor_Service: LetterrequestcustomerFactorService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService,
  ) { }


  DataList_LetterrequestcustomerFactor: Array<General_Interface> = []
  DataList_LetterrequestcustomerFactorDetail: Array<General_Interface> = []


  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.ReadData_LetterrequestcustomerFactor()


  }

  ReadData_LetterrequestcustomerFactor() {
    this.Procssing = true
    this.LetterrequestcustomerFactor_Service.GetFactor(this.Token, this.inner_Letter.id).subscribe(
      data => {
        this.DataList_LetterrequestcustomerFactor = data['record']
        this.DataList_LetterrequestcustomerFactorDetail = data['result']
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  Add_uploadImage1() {

    this.Procssing = true
    this.LetterrequestcustomerFactor_Service.Add(this.Token, this.UploadImageSrc, this.inner_Letter.id).subscribe(
      data => {
        this.UploadImageSrc=''
        this.Procssing = false
        this.Alertify_Service.SuccessMessage("Information saved successfully.")
        this.ReadData_LetterrequestcustomerFactor()
      }
    )
  }

  DeleteData(item: General_Interface) {
    this.Procssing = true
    this.LetterrequestcustomerFactor_Service.Delete(this.Token, item.id).subscribe(
      data => {
        this.Procssing = false
        this.Alertify_Service.SuccessMessage("Information deleted successfully.")
        this.ReadData_LetterrequestcustomerFactor()
      }
    )
  }


  OnSet_Back_LetterrequestcustomerFactorList() {
    this.OnBack_LetterrequestcustomerFactor_Action.emit(-1);

  }


  //#region Image
  BaseUrl = environment.BaseUrl
  UploadImageSrc_List: Array<General_Interface> = []
  UploadImageSrc: string = ''
  InProccessing_Image1: boolean = false
  uploadImage1(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_Image1 = true

    this.LetterrequestcustomerFactor_Service.uploadFile(formData, this.Token).subscribe(
      data => {
        this.InProccessing_Image1 = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("File uploaded successfully.")
          this.UploadImageSrc = data['filename']
        }
      }
    )

  }

  Remove_uploadImage1() {
    this.UploadImageSrc = ''
  }

  UploadImageSrc_List_Delete(id: number) {
    this.UploadImageSrc_List.splice(id, 1)
    this.Alertify_Service.SuccessMessage("Deleted successfully.")
  }

  modalRef_Image: any;
  ModalimageUrl: string = ''
  openModal(template: TemplateRef<any>, imageUrl: string) {
    this.ModalimageUrl = imageUrl
    this.modalRef_Image = this.modalService.show(template);
  }

  //#endregion




}
